"use strict";
/**@description You can save and load any object by calling this class instead of LocalStorage */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Encode_1 = __importDefault(require("./Encode"));
var deviceKey = ((new Date()).getTimezoneOffset() / 60) + window.screen.width + navigator.product + window.screen.height + navigator.language + window.screen.colorDepth + navigator.platform + window.screen.pixelDepth;
//alert("browserLanguage:");
//alert("browserPlatform:");
//alert("sizeScreenW:");
//alert("sizeScreenH:");
//alert("scrColorDepth:");
//alert("scrPixelDepth:");
var GlobalStorage = {
    load: load,
    save: save
};
/**@description It will return a save status as a string throw the result of the function */
function save(id, value) {
    id = window.location.host + id;
    try {
        localStorage.setItem(Encode_1.default.encrypt(id, deviceKey, true), Encode_1.default.encrypt(JSON.stringify(value), deviceKey));
        return '';
    }
    catch (e) {
        return e.toString();
    }
}
/**@description Load the saved object as an parsed object */
function load(id) {
    id = window.location.host + id;
    var loadedVal = localStorage.getItem(Encode_1.default.encrypt(id, deviceKey, true));
    if (loadedVal === null) {
        return null;
    }
    else {
        return JSON.parse(Encode_1.default.decrypt(loadedVal, deviceKey));
    }
}
exports.default = GlobalStorage;
//# sourceMappingURL=GlobalStorage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/saffroncodejs/lib/libs/GlobalStorage.js
// module id = 106
// module chunks = 0